import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M16.375 8.25v6.125c0 .492-.41.875-.875.875a.864.864 0 0 1-.875-.875v-3.992l-5.523 5.496a.843.843 0 0 1-1.23 0 .843.843 0 0 1 0-1.23l5.495-5.524H9.375A.864.864 0 0 1 8.5 8.25c0-.465.383-.875.875-.875H15.5a.9.9 0 0 1 .875.875"
    }, null, -1)
  ]))]))
}
export default { render: render }